import { DOCUMENT_ERROR_SOURCE } from 'shared/domain/document/documentError';
import { MAX_DISPLAY_FILE_SIZE } from 'shared/domain/document/documentLimits';
import { documentService } from 'services/documentService';
import { signedRequestService } from '../signedRequestService';
import {
  ResolveDocumentPreviewSourcesInput,
  ResolveDocumentPreviewSourcesResult,
} from './types';

export class DocumentPreviewService {
  async resolveDocumentPreviewSources({
    fileForDownload,
    existingFile,
    response,
  }: ResolveDocumentPreviewSourcesInput): Promise<ResolveDocumentPreviewSourcesResult> {
    const src = signedRequestService.resolveDocumentOriginalSource(response);

    const downloadSrc = signedRequestService.resolveDocumentDownloadSource(
      fileForDownload,
      response
    );

    let thumbnail = signedRequestService.resolveDocumentThumbnailSource(
      existingFile,
      response
    );

    if (!thumbnail) {
      thumbnail =
        signedRequestService.resolveThumbnailUrlFromSignedRequest(
          response.documentUrls
        );

      if (!thumbnail && existingFile.thumbnail && existingFile.thumbnail !== DOCUMENT_ERROR_SOURCE) {
        thumbnail = existingFile.thumbnail;
      } else if (
        !thumbnail &&
        existingFile.src &&
        existingFile.src !== DOCUMENT_ERROR_SOURCE
      ) {
        const isBlobSrc =
          typeof existingFile.src === 'string' &&
          existingFile.src.startsWith('blob:');
        if (isBlobSrc) {
          thumbnail = existingFile.src;
        } else {
          thumbnail = DOCUMENT_ERROR_SOURCE;
        }
      } else if (!thumbnail) {
        thumbnail = DOCUMENT_ERROR_SOURCE;
      }
    }

    return {
      src,
      downloadSrc,
      thumbnail,
    };
  }
}

export const documentPreviewService = new DocumentPreviewService();

export type {
  ResolveDocumentPreviewSourcesInput,
  ResolveDocumentPreviewSourcesResult,
} from './types';
